import React, { Component } from 'react';
import './UserDetailsCard.css';
import Card from '../../components/card/Card';
import LabelAndValue from '../../components/labelAndValue/LabelAndValue';
import Input from '../../inputs/input/Input';
import models from '../../model/models';
import Label from '../../components/label/Label';
import utils from 'utils/utils.js';
import Button from '../../components/button/Button';
import mainAPI from '../../api/MainAPI';
import FormTemplate from '../../components/templates/formTemplates/FormTemplate';
import DiscrepancyPopup from '../../popups/discrepancyPopup/DiscrepancyPopup';
import toasts from '../../utils/toasts';

let isEmpty = (value) => {
	if (value === null) return true;
	if (value === undefined) return true;
	if (value === '') return true;
	return false;
};

class EditUserModal extends FormTemplate {
	constructor(props) {
		super(props);
		const { user } = this.props;
		this.state = {
			updatedUser: {
				first_name: user.first_name,
				last_name: user.last_name,
        primary_email: user.primary_email,
				// phone_number: user.phone_number,
				certification_number: user.certification_number,
				position: user.position,
				role: user.role
			}
		};
	}

	_save = () => {
		if (!this.isValid()) return;
		let updatedUser = this.getValue();
		for (let i in updatedUser) {
      const hasNotChanged = updatedUser[i] == this.state.updatedUser[i]
			if (hasNotChanged) {
				delete updatedUser[i];
        continue;
			}
      const isEmptyProperty = isEmpty(updatedUser[i]) && isEmpty(this.state.updatedUser[i])
			if (isEmptyProperty) {
				delete updatedUser[i];
        continue;
			}
			if (i === 'primary_email' && !utils.isValidEmail(updatedUser[i])) {
				return toasts.show('Email not valid');
			}
		}
		if (this._isEditingSomeoneElsesAccount()) {
			return window.popupController.show(DiscrepancyPopup, {
				title: 'Are you sure you want to edit this user?',
				notesPlaceholder: 'Why are you editing this?',
				onComplete: (options) => {
					updatedUser.notes = options.notes;
					this._completeEdit(updatedUser);
					return true;
				}
			});
		}
		this._completeEdit(updatedUser);
	};

	_completeEdit = (updatedUser) => {
		const { onClose } = this.props;
		updatedUser = { ...updatedUser, id: this.props.user.id };
		models.user.save(updatedUser);
		onClose();
	};

	_isEditingSomeoneElsesAccount = () => {
		let accountEditing = this.props.user;
		let currentUser = models.user.getCurrent();
		if (!accountEditing) return false;
		else if (!currentUser) return false;
		else if (accountEditing.id === currentUser.id) return false;
		return true;
	};

	render() {
		const { onClose } = this.props;
		const {
			updatedUser: { first_name, last_name, certification_number, position, primary_email }
		} = this.state;
		return (
			<div className="EditUserModal">
				<div className="EditUserModal-popup">
					<div className="EditUserModal-background" onClick={onClose} />
					<div className="EditUserModal-card">
						<div className="EditUserModal-card-header">
							<Label large black className="InviteUsersModal-card-label">
								Edit
							</Label>
						</div>
						<div className="EditUserModal-card-inputs">
							<div className="EditUserModal-card-inputs-field">
								<Label className="EditUserModal-card-inputs-field-label" gray-medium />
								<Input
									required
									iconName="icon-person"
									value={first_name}
									placeholder="First Name"
									ref={(ref) => {
										this.myRefs.first_name = ref;
									}}
								/>
							</div>
							{/*<div className="EditUserModal-card-inputs-field">*/}
							{/*	<Label className="EditUserModal-card-inputs-field-label" gray-medium />*/}
							{/*	<Input*/}
							{/*		iconName="icon-phone"*/}
							{/*		value={phone_number}*/}
							{/*		placeholder="Phone Number"*/}
							{/*		ref={(ref) => {*/}
							{/*			this.myRefs.phone_number = ref;*/}
							{/*		}}*/}
							{/*	/>*/}
							{/*</div>*/}
							<div className="EditUserModal-card-inputs-field">
								<Label className="EditUserModal-card-inputs-field-label" gray-medium />
								<Input
									iconName="icon-phone"
									value={certification_number}
									placeholder="Cert/License Number"
									ref={(ref) => {
										this.myRefs.certification_number = ref;
									}}
								/>
							</div>

							<div className="EditUserModal-card-inputs-field">
								<Label className="EditUserModal-card-inputs-field-label" gray-medium />
								<Input
									required
									iconName="icon-person"
									value={last_name}
									placeholder="Last Name"
									ref={(ref) => {
										this.myRefs.last_name = ref;
									}}
								/>
							</div>

							<div className="EditUserModal-card-inputs-field">
								<Label className="EditUserModal-card-inputs-field-label" gray-medium />
								<Input
									required
									iconName="icon-person"
									value={position}
									placeholder="Position"
									ref={(ref) => {
										this.myRefs.position = ref;
									}}
								/>
							</div>

							<div className="EditUserModal-card-inputs-field">
								<Label className="EditUserModal-card-inputs-field-label" gray-medium />
								<Input
									required
									iconName="icon-phone"
									value={primary_email}
									placeholder="Email"
									ref={(ref) => {
										this.myRefs.primary_email = ref;
									}}
								/>
							</div>
						</div>
						<div className="EditUserModal-card-actions">
							<Button onClick={this._save} className="EditUserModal-card-actions-button" color="white" bg="blue">
								Save
							</Button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default class UserDetailsCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			edit: false
		};
	}

	componentDidMount = () => {
		this.subscribeId = models.user.onChange(this._getData);
	};

	componentWillUnmount = () => {
		models.user.unsubscribe(this.subscribeId);
	};

	_getData = (attempt=0) => {
		if(attempt > 4) return;
		let user = models.user.obj(this.props.userId);
		let currentUser = models.user.getCurrent();
		if(!currentUser){
			setTimeout(() => {
			   this._getData(attempt++)
			}, 200)
		}
		this.setState({ user , currentUser });
	};

	_disable = async () => {
		await mainAPI.user.disable(this.props.userId);
		toasts.show('User disabled for this agency.')
		models.user.refreshData();
	};

	_enable = async () => {
		await mainAPI.user.enable(this.props.userId);
		models.user.refreshData();
	};

	_disableAdmin = async () => {
		await mainAPI.user.disable_admin(this.props.userId);
		models.user.refreshData();
	};

	_enableAdmin = async () => {
		await mainAPI.user.enable_admin(this.props.userId);
		models.user.refreshData();
	};

	isInactiveUser = () => {
		let user = this.state.user;
		if (!user && !user.inactive_after_date && !user.inactive_after_date.getTime) return false;
		if (isNaN(user.inactive_after_date.getTime())) {
			return false;
		} else return true;
	};

	_renderEnableDisableBtn = () => {
		let user = this.state.user;
		if (!user) return;
		if (this.isInactiveUser()) {
			return (
				<Button className="enable-btn" bg="blue" color="white" onClick={this._enable}>
					Enable
				</Button>
			);
		} else {
			return (
				<Button className="disable-btn" bg="red" color="white" onClick={this._disable}>
					Disable
				</Button>
			);
		}
	};

	_renderEnableDisableAdminBtn = () => {
		let user = this.state.user;
		if (!user) return;
		if (user.role === 'user') {
			return (
				<Button className="enable-btn admin" bg="blue" color="white" onClick={this._enableAdmin}>
					Make Admin
				</Button>
			);
		} else {
			return (
				<Button className="disable-btn admin" bg="red" color="white" onClick={this._disableAdmin}>
					Disable Admin
				</Button>
			);
		}
	};

	_renderWhenDisabled = () => {
		let user = this.state.user;
		if (!user) return;
		if (this.isInactiveUser()) {
			return <LabelAndValue className={'red'} label="Disabled" value={utils.display_date(user.inactive_after_date)} />;
		}
	};

	_renderUserEditBtn = () => {
		let accountEditing = this.state.user;
		let currentUser = this.state.currentUser;
		if (!accountEditing) return null;
		else if (!currentUser) return null;
		else {
			return (
				<Button onClick={this._openEditModal} className="edit-btn admin" bg="blue" color="white">
					Edit
				</Button>
			);
		}
	};

	_openEditModal = () => {
		this.setState({
			edit: true
		});
	};

	_closeEditModal = () => {
		this.setState({
			edit: false
		});
	};

	render() {
		let user = this.state.user || {};

		const { edit } = this.state;
		return (
			<Card className="g-user-details-card">
				{edit && <EditUserModal user={user} onClose={this._closeEditModal} />}
				<Label large black>
					Details
				</Label>
				<div className="button-container">
					{this._renderEnableDisableAdminBtn()}
					{this._renderEnableDisableBtn()}
					{this._renderUserEditBtn()}
				</div>
				<div className="data">
					<LabelAndValue label="First Name" value={user.first_name} />
					<LabelAndValue label="Last Name" value={user.last_name} />
					<LabelAndValue label="Email" value={user.primary_email} />
					<LabelAndValue label="Phone Number" value={user.phone_number} />
					<LabelAndValue label="Cert/License Number" value={user.certification_number} />
					<LabelAndValue label="Position" value={user.position} />
					<LabelAndValue label="Role" value={user.role} />
					{this._renderWhenDisabled()}
					<LabelAndValue label="Last Active" value={utils.display_date(user.last_active_on)} />
				</div>
			</Card>
		);
	}
}



// WEBPACK FOOTER //
// ./src/cards/userDetailsCard/UserDetailsCard.jsx